/**
 * Onboarding message style guide
 *
 * Keep copy consistent across screens:
 * - `eyebrow`: one-word section label (e.g., Shop, Cook, Pantry)
 * - `title`: clear 2-5 word benefit-oriented heading
 * - `description`: one sentence in plain language, action-first tone
 *
 * Voice and tone:
 * - Friendly and practical, never salesy
 * - Focus on what users can do now
 * - Prefer concise verbs: build, save, track, load, organize
 *
 * Content constraints:
 * - Avoid feature overload; mention only primary outcomes
 * - Avoid punctuation-heavy or marketing phrasing
 * - Keep descriptions roughly one line on desktop when possible
 *
 * Persistence:
 * - Every message needs a unique versioned key: `agent_onboarding_<screen>_intro_seen_v#`
 * - Bump version when copy meaningfully changes so users can see updated guidance
 */
export const ONBOARDING_BANNER_FLAGS = {
  shopIntro: false,
  cookIntro: false,
  pantryIntro: false,
}

export const ONBOARDING_MESSAGES = {
  shopIntro: {
    storageKey: 'agent_onboarding_shop_intro_seen_v1',
    eyebrow: 'Shop',
    title: 'Your grocery run',
    description:
      'Build your list, match it to your store aisles, and add ingredients from saved recipes in one place.',
  },
  cookIntro: {
    storageKey: 'agent_onboarding_cook_intro_seen_v1',
    eyebrow: 'Cook',
    title: 'Your recipe hub',
    description:
      'Save recipes, organize your favorites, and load ingredients straight into Shop when you are ready to cook.',
  },
  pantryIntro: {
    storageKey: 'agent_onboarding_pantry_intro_seen_v1',
    eyebrow: 'Pantry',
    title: 'What you have on hand',
    description:
      'Add what’s in the pantry, fridge, and freezer so recipes and shopping lists match what you have.',
  },
}

export function getOnboardingMessage(messageId) {
  return ONBOARDING_MESSAGES[messageId] || null
}
